import type { FC } from 'react';
import * as React from 'react';
import { useSigninCheck } from 'reactfire';
import Login from './Login/Login';
import { useAtom } from 'jotai';
import userTokenAtom from '../../data/atoms/userTokenAtom';

interface IProps {
  children: React.ReactNode;
}

const AuthCheck: FC<IProps> = ({ children }) => {

  const userToken = useAtom(userTokenAtom);

  const { status, data: signInCheckResult  } = useSigninCheck();

  if (status === 'loading') {
    return <div>auth</div>;
  }

  if (signInCheckResult.signedIn && userToken[0]) {

    return <>{children}</>;
  } else {
    return <Login />;
  }
};

export default AuthCheck;
